var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoughnutWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 267,
    viewBox: "0 0 266 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133 0.320312C59.55 0.320312 0 59.8703 0 133.32C0 206.77 59.55 266.32 133 266.32C206.45 266.32 266 206.77 266 133.32C266 59.8703 206.45 0.320312 133 0.320312ZM133 227.69C80.88 227.69 38.63 185.44 38.63 133.32C38.63 81.2003 80.88 38.9503 133 38.9503C185.12 38.9503 227.37 81.2003 227.37 133.32C227.37 185.44 185.12 227.69 133 227.69Z",
    fill: "#EDEDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoughnutWhite);
export default __webpack_public_path__ + "static/media/doughnut-white.597706e5f85dabde52c4cdb460dc2820.svg";
export { ForwardRef as ReactComponent };